// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Lora', 'Lora Fallback', serif","fontWeight":500,"fontStyle":"normal"},"className":"__className_4bec31","variable":"__variable_4bec31"};